
/**
 * `Overlay` - general scroll hint overlay.
 */
import Vue from 'vue';
import { OPTIONS } from './Overlay.config';
import {
  OverlayData,
  OverlayObserverOptions,
  OverlayObserverIntersectionEntries,
  OverlayObserverIntersectionCallback,
} from './Overlay';

const initOverlayObserver = (
  callback: OverlayObserverIntersectionCallback,
  options: OverlayObserverOptions,
): IntersectionObserver => new IntersectionObserver(callback, options);

export default Vue.extend({
  name: 'owc-overlay',
  data: (): OverlayData => ({
    isActive: true,
    overlayObserver: null,
  }),
  props: {
    timeOut: {
      type: Number,
      required: false,
      default: 3000,
    },
    isDarkMode: {
      type: Boolean,
      default: false,
    },
    hideOnHover: {
      type: Boolean,
      default: true,
    },
    hideOnClick: {
      type: Boolean,
      default: false,
    },
    threshold: {
      type: Number,
    },
    reactivated: {
      type: Boolean,
    },
  },
  computed: {
    overlayObserverThreshold(): number {
      const { threshold } = OPTIONS;
      return this.threshold || threshold;
    },
  },
  methods: {
    intersectionCallback(entries: OverlayObserverIntersectionEntries) {
      //here we are only selecting the first element because every observer is unique to its own overlay
      const [firstIntersectionObserverEntry] = entries;
      if (firstIntersectionObserverEntry && firstIntersectionObserverEntry.isIntersecting) {
        this.$emit('overlayOpen');
        setTimeout(this.hide, this.timeOut);
      }
    },
    hide(): void {
      this.isActive = false;
      if (this.overlayObserver) {
        this.overlayObserver.unobserve(this.$el);
        this.overlayObserver.disconnect();
      }
    },
    handleMouseOver(): void {
      this.hideOnHover && this.hide();
    },
    handleMouseDown(): void {
      this.hideOnClick && this.hide();
    },
  },
  watch: {
    isActive(isActiveNewValue: boolean) {
      if (isActiveNewValue === false) {
        this.$emit('overlayClose');
      }
    },
  },
  mounted() {
    // here we initialize the observer, intersecting with the root (viewport)
    this.overlayObserver = initOverlayObserver(this.intersectionCallback, {
      ...OPTIONS,
      threshold: this.overlayObserverThreshold,
    });
    this.overlayObserver.observe(this.$el);
  },
});
